import { useState, useEffect, useCallback } from 'react'
import { useAuthStore } from '@store/authStore'
import api from '@api/axios'

/**
 * Hook to fetch real analytics data for dashboard charts
 */
export const useAnalytics = () => {
    const [data, setData] = useState({
        trends: [],
        statusDistribution: [],
        departmentWorkload: [],
        formPerformance: []
    })
    const [isLoading, setIsLoading] = useState(true)
    const [error, setError] = useState(null)
    const { token } = useAuthStore()

    const fetchAnalytics = useCallback(async () => {
        if (!token) return

        setIsLoading(true)
        setError(null)

        try {
            const response = await api.get('/analytics/dashboard')
            // axios interceptor already returns response.data, so response is { success, data }
            if (response?.data) {
                setData(response.data)
            }
        } catch (err) {
            console.error('Failed to fetch analytics:', err)
            setError(err.message || 'Failed to fetch analytics')
        } finally {
            setIsLoading(false)
        }
    }, [token])

    useEffect(() => {
        fetchAnalytics()
    }, [fetchAnalytics])

    return {
        ...data,
        isLoading,
        error,
        refetch: fetchAnalytics
    }
}

export default useAnalytics
